<template>
  <div class="main is-fullhd">
    <div class="columns top_bar">
      <div class="column  zp">
        <hero-header></hero-header>
      </div>
      <div class="column reward is-narrow">
        <h4 class="title">{{getReward()}}</h4>
      </div>
    </div>

    <section class="section all_jobs">
      <div id="app" class="container job-app">
        <router-view/>
      </div>
    </section>
  </div>
</template>

<script>
  import StatsBar from './components/jobs/StatsBar';
  import HeroHeader from './components/jobs/HeroHeader';

  export default {
    name: 'app',
    methods: {
      getReward() {
        const num = new Intl.NumberFormat('ch-CH').format(2000);
        return `Up to CHF ${num}`;
      },
    },
    components: {
      StatsBar,
      HeroHeader,
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss">

  @import "./styles/variables";

  .job-app {
    width: 100% !important;
    min-width: 100% !important;
  }


  section.hero {
    background: $tamedia_grey3;
  }

  .tamedia-logo {
    width: 65px;
    height: 65px;
    margin: -7px 0 0 0;
  }

  nav.level {
    background: $tamedia_red;
    color: $tamedia_grey;
    padding: 1.5rem 0;

    .title {
      color: $tamedia_grey;
    }
  }
  .all_jobs {
    padding: 1.5rem;
  }
  .top_bar {
    margin: 0 !important;
    background: $tamedia_grey;
    height: 100px;


    div.column.zp {
      padding: 0;
    }

    div.reward {
      color: white;

      h4{
        color: white;
        margin: 20px 1rem 0 0;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/App.vue